import React from 'react';
import { UserCircle, LogOut } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 px-8 py-6 flex justify-between items-start bg-gradient-to-b from-[#0B1120]/95 to-transparent" data-id="element-80">
      {/* Left: Logo & Title */}
      <div className="flex items-center gap-6" data-id="element-81">
        <div className="relative group" data-id="element-82">
          <div className="absolute inset-0 bg-[#0EA5E9]/30 blur-xl rounded-full group-hover:bg-[#0EA5E9]/50 transition-all duration-500" data-id="element-83"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9TBG8hPB9KQsVxWxybmv7d/image.png" alt="北京交通大学附属中学校徽" className="w-20 h-20 relative z-10 drop-shadow-[0_0_15px_rgba(14,165,233,0.4)]" data-id="element-84" />
        </div>
        <div data-id="element-85">
          <h2 className="text-[#0EA5E9]/70 text-xs tracking-[0.3em] mb-1 font-mono uppercase" data-id="element-86">
            北京交通大学附属中学
          </h2>
          <h1 className="text-4xl font-bold text-white tracking-wide text-glow mb-1" data-id="element-87">
            EDU-Brain · 校园智慧教育大脑
          </h1>
          <div className="flex items-center gap-3 mt-2" data-id="element-88">
            <div className="h-px w-12 bg-gradient-to-r from-[#0EA5E9] to-transparent" data-id="element-89"></div>
            <p className="text-sm text-[#0EA5E9]/90 font-medium tracking-wider" data-id="element-90">
              易教智能体 (E-teach Agent)
            </p>
            <div className="h-px w-12 bg-gradient-to-l from-[#0EA5E9] to-transparent" data-id="element-91"></div>
          </div>
          <p className="text-xs text-gray-400 mt-1.5 tracking-wide" data-id="element-92">
            赋能每一刻成长
          </p>
        </div>
      </div>

      {/* Right: User Profile */}
      <div className="flex items-center gap-4" data-id="element-93">
        <div className="flex items-center gap-3 glass-panel px-4 py-2 rounded-full border-[#0EA5E9]/20" data-id="element-94">
          <UserCircle className="w-6 h-6 text-[#0EA5E9]" data-id="element-95" />
          <span className="text-sm font-bold text-white" data-id="element-96">管理员</span>
        </div>
        <button className="p-2 glass-panel rounded-full hover:bg-white/10 transition-colors text-gray-400 hover:text-white border-[#0EA5E9]/10" data-id="element-97">
          <LogOut className="w-5 h-5" data-id="element-98" />
        </button>
      </div>
    </header>;
}